export enum TripActionTypes {
    SET_TRIPS = "SET_TRIPS",
    CLEAR_TRIPS = "CLEAR_TRIPS"
}